<template>
	<div class="experience-extras">
		<div class="experience-extras__block" v-for="(ticket, index) in products" :key="ticket.type.id">
			<div
				class="experience-block__white-header"
				:class="{ 'experience-block__white-header--first': index === 0 }"
			>
				{{ ticket.numproducts }}x {{ ticket.type.name }}
			</div>
		</div>

		<div v-if="!hideChangeButtons">
			<div class="experience-extras__button-container" v-if="!isShopUpdatePending">
				<Button class="experience-extras__button button--small" :to="route"> {{ buttonLabel }} </Button>

				<Button class="experience-extras__button button--small" @click.native="removeItems">
					{{ $t('page.shop.experience_builder.extras.remove') }}
				</Button>
			</div>

			<div v-else>
				<Spinner />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ExperienceContentExtras',

	props: {
		products: Array,
		route: String,
		buttonLabel: String,
		hideChangeButtons: Boolean
	},

	computed: {
		shopCart() {
			return this.$store.getters['shopconfig/getCart'];
		},

		isShopUpdatePending() {
			return this.$store.getters['shopapi/getIsShopUpdatePending'];
		}
	},

	methods: {
		removeItems() {
			this.$fireErrorEventWithPromis(6001).then(response => {
				this.$store.dispatch('shopapi/removeOptionFromExperienceBuilder', this.products);

				const productsToRemove = [];

				this.products.forEach(product => {
					if (product.type.slug !== 'shipping') {
						const tempData = {
							name: product.type.meta.name,
							price: product.type.price,
							productId: product.type.id,
							amount: product.numproducts,
							shop: this.$store.getters['shopconfig/getData'].titleFull,
							type: product.type.mappedType
						};
						productsToRemove.push(tempData);
					}
				});
				productsToRemove.length &&
					this.removeFromDataLayer({
						products: productsToRemove
					});
			});
		}
	}
};
</script>

<style lang="scss">
$component: 'experience-extras';

.#{$component} {
	&__includes {
		margin-bottom: calc($global-spacing / 2);

		font-size: 16px;
		text-transform: uppercase;
	}

	&__perks {
		padding: 0 $global-spacing;
		margin-bottom: $global-spacing;

		font-size: 14px;
	}

	&__perk {
		display: flex;
	}

	&__perk-icon {
		margin: 5px 10px 0 0;
		flex-shrink: 0;
	}

	&__button-container {
		display: flex;
		padding: calc($global-spacing / 2) $global-spacing $global-spacing;
		justify-content: space-around;
	}

	&__button {
		max-width: 200px;
	}
}
</style>
